import React from "react";

// reactstrap components
import {
  Button,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import LandingPageHeader from "components/Headers/LandingPageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import DarkFooter from "components/Footers/DarkFooter";
import PanelCountdown from "components/PanelCountdown";

function LandingPage() {
  const [firstFocus, setFirstFocus] = React.useState(false);
  const [lastFocus, setLastFocus] = React.useState(false);
  React.useEffect(() => {
    document.body.classList.add("landing-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("landing-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);
  return (
    <>
      <IndexNavbar />

      <div className="wrapper">
        <LandingPageHeader />
        {/* <header className="position-relative vh-100 overflow-hidden">
            <video className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover" autoPlay muted loop playsInline>
            <source src={require("assets/img/macau-tourism.mp4")} type="video/mp4" />
            Your browser does not support the video tag.
            </video>
            <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>
            <div className="container h-100 d-flex flex-column justify-content-center align-items-center text-white position-relative z-1 text-center">
            <h1 className="display-4 fw-bold">Experience Macao</h1>
            <p className="lead">Where East meets West</p>
            </div>
        </header> */}
        <div className="section section-about-us">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h2 className="title">ABOUT MACAU</h2>
                <h3>Where Cultures Meet and Dreams Come Alive</h3>
                <h5 className="description text-justify">
                  Macau is a dazzling destination where East meets West — a city
                  that seamlessly blends ancient Chinese traditions, elegant
                  Portuguese heritage, and thrilling modern entertainment.
                  Whether you're wandering through its UNESCO-listed historic
                  streets, savoring world-class cuisine, or watching the city
                  light up from a sky-high tower, Macau offers something for
                  every kind of traveler.
                </h5>
              </Col>
            </Row>
            <div className="separator separator-primary"></div>
            <div className="section-story-overview">
              <Row>
                <Col md="6">
                  <div
                    className="image-container image-left"
                    style={{
                      backgroundImage:
                        "url(" +
                        require("assets/img/Macau-2026/about/macau-1.png") +
                        ")",
                    }}
                  ></div>
                  <div
                    className="image-container"
                    style={{
                      backgroundImage:
                        "url(" +
                        require("assets/img/Macau-2026/about/macau-3.png") +
                        ")",
                    }}
                  ></div>

                  <p className="blockquote blockquote-info">
                    <span className="font-weight-bold h5">Do You Know?</span>
                    <br />
                    <span className="font-italic">
                      {" "}
                      "Macau, often dubbed the “Las Vegas of China,” is located
                      just an hour west of Hong Kong. Renowned as the “Gambling
                      Capital of the World,” it generates more gaming revenue
                      than Las Vegas, making it the top destination for
                      high-stakes entertainment."
                    </span>
                  </p>
                </Col>
                <Col md="5">
                  <div
                    className="image-container image-right"
                    style={{
                      backgroundImage:
                        "url(" +
                        require("assets/img/Macau-2026/about/stPaul.png") +
                        ")",
                    }}
                  ></div>
                  <p className="">
                    Nestled on the southern coast of China, Macau is a vibrant
                    city that seamlessly blends Portuguese colonial heritage
                    with modern Chinese culture. Known as the "Las Vegas of
                    Asia," this special administrative region of China dazzles
                    visitors with its luxurious casinos, extravagant hotels, and
                    glittering nightlife. But beyond the glitz, Macau offers a
                    rich tapestry of history, architecture, cuisine, and
                    traditions that make it a truly unique destination.
                  </p>
                  <p>
                    Macau is home to some of the world’s most renowned casinos,
                    including The Venetian Macau, Galaxy Macau, and City of
                    Dreams, where luxury shopping, fine dining, and extravagant
                    shows await. But adventure isn't limited to gambling—visit
                    the Macau Tower for skywalking or bungee jumping, offering
                    panoramic views of the cityscape and South China Sea.
                  </p>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <DarkFooter />
        <PanelCountdown date="03/03/2026" />
      </div>
    </>
  );
}

export default LandingPage;
